import React from 'react'
import styled, { CSSProp, DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';
import { getColor } from '../styling/mixins/colors';


interface TextSeparatorProps {
    textToShow?: string;
    classNameForText?: string;
    classNameForElement?: string;
    bgColor?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
}

const StyledTextSeparator = styled.div<TextSeparatorProps>`
    width: 100%;
    position: relative;
    margin-top: 36px;
    margin-bottom: 75px;

    hr {
        margin: 0;
        width: 100%;
    }
        
    span {
        position: absolute;
        top: -0.5em;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        background-color: ${({ bgColor }) => bgColor};
        padding: 0px 16px;
        color:${getColor("gray", 600)};
        font-weight: bold;
    }
`;


export const TextSeparator = (props: TextSeparatorProps) => {
    return (
        <StyledTextSeparator bgColor={props.bgColor} className={props.classNameForElement}>
            <span className={props.classNameForText}>{props.textToShow?.toUpperCase()}</span>
        </StyledTextSeparator>
    )
}